<script>
import HeaderContentLayout from '@/router/layouts/header-content-layout';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const SingleConfigRepository = Repositories.get('singleconfigs');
import { required, between } from 'vuelidate/lib/validators';
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import { DEFAULT_EMAILS } from '@/mixins/defaultEmail.js';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Orders',
  },
  mixins: [DEFAULT_EMAILS],
  components: {
    Loading,
    HeaderContentLayout,
    Tooltip,
  },
  data() {
    return {
      isLoading: false,
      items: [
        {
          text: 'orders',
          href: '/configuration/orders',
        },
        {
          text: '',
          active: true,
        },
      ],
      ordersConfig: null,
      selectedLang: null,
      emailsConfig: null,
      currentFocusedBox: '',
      approveOrderText: '',
      approvedOrderText: '',
      approveOrderTitle: '',
      approvedOrderTitle: '',
      isModifyStartingNumber: false,
      oldStartingNumber: 0,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    insertText(text) {
      const textarea = this.$refs[this.currentFocusedBox];

      if (textarea != undefined) {
        // Insert text into current position
        let cursorPos = textarea.$refs.input.selectionEnd; // Get current Position
        if (cursorPos === null || cursorPos === undefined) {
          cursorPos = 0;
        }

        if (this.currentFocusedBox == 'approveEmailTextRef') {
          this.approveOrderText =
            this.approveOrderText.substring(0, cursorPos) +
            text +
            this.approveOrderText.substring(cursorPos);
        } else if (this.currentFocusedBox == 'approvedEmailTextRef') {
          this.approvedOrderText =
            this.approvedOrderText.substring(0, cursorPos) +
            text +
            this.approvedOrderText.substring(cursorPos);
        } else if (this.currentFocusedBox == 'approvedEmailTitleRef') {
          this.approvedOrderTitle =
            this.approvedOrderTitle.substring(0, cursorPos) +
            text +
            this.approvedOrderTitle.substring(cursorPos);
        } else if (this.currentFocusedBox == 'approveEmailTitleRef') {
          this.approveOrderTitle =
            this.approveOrderTitle.substring(0, cursorPos) +
            text +
            this.approveOrderTitle.substring(cursorPos);
        }

        // Get new cursor position
        cursorPos += text.length;

        // Wait until vue finishes rendering the new text and set the cursor position.
        this.$nextTick(() => {
          textarea.$refs.input.selectionStart = cursorPos;
          textarea.$refs.input.selectionEnd = cursorPos;
          textarea.focus();
        });
      }
    },
    loadData() {
      this.isLoading = true;
      let promise1 = SingleConfigRepository.get('OrdersConfig').then(
        ({ data }) => {
          this.ordersConfig = { ...data, isUpdatedStartingNumber: false };
        }
      );

      let promise2 = SingleConfigRepository.get('EmailsConfig')
        .then(({ data }) => {
          this.emailsConfig = [...data];
        })
        .catch(() => {
          this.emailsConfig = [];
        });

      Promise.all([promise1, promise2])
        .then(() => {
          this.isLoading = false;
          this.selectedLang = this.$i18n.locale;
        })
        .catch(() => {
          this.selectedLang = this.$i18n.locale;
          this.isLoading = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    saveConfig() {
      this.$v.ordersConfig.$touch();

      if (!this.$v.ordersConfig.$invalid) {
        this.isLoading = true;

        if (this.isModifyStartingNumber) {
          this.ordersConfig.isUpdatedStartingNumber = true;
        }

        let promise1 = SingleConfigRepository.update(
          { jsonString: JSON.stringify(this.ordersConfig) },
          'OrdersConfig'
        ).then(({ data }) => {
          this.$v.ordersConfig.$reset();
          this.ordersConfig = { ...data, isUpdatedStartingNumber: false };
          this.isModifyStartingNumber = false;

          this.$store.dispatch('cache/setOrdersConfig', {
            ...this.ordersConfig,
          });
        });

        let emailObject = {
          language: this.selectedLang,
          approveOrderText: this.approveOrderText
            .replaceAll('\r\n', '%0D%0A')
            .replaceAll('\n', '%0D%0A'),
          approvedOrderText: this.approvedOrderText
            .replaceAll('\r\n', '%0D%0A')
            .replaceAll('\n', '%0D%0A'),
          approveOrderTitle: this.approveOrderTitle,
          approvedOrderTitle: this.approvedOrderTitle,
        };

        let foundIndex = this.emailsConfig.findIndex(
          (x) => x.language == this.selectedLang
        );

        if (foundIndex < 0) {
          this.emailsConfig.push(emailObject);
        } else {
          this.emailsConfig[foundIndex] = emailObject;
        }

        let promise2 = SingleConfigRepository.update(
          { jsonString: JSON.stringify(this.emailsConfig) },
          'EmailsConfig'
        );

        Promise.all([promise1, promise2])
          .then(() => {
            this.isLoading = false;
            this.$toast.successToast(this.$t('general.saved'));
          })
          .catch(() => {
            this.isLoading = false;
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          });
      }
    },
    resetStartingNumber() {
      this.oldStartingNumber = this.ordersConfig.startingNumber;
      this.ordersConfig.startingNumber = null;
      this.isModifyStartingNumber = true;
      this.$nextTick(() => this.$refs.startingNumberInput.focus());
    },
    cancelResetStartingNumber() {
      if (this.isModifyStartingNumber) {
        this.ordersConfig = {
          ...this.ordersConfig,
          startingNumber: this.oldStartingNumber,
          isUpdatedStartingNumber: false,
        };
        this.$nextTick(() => (this.isModifyStartingNumber = false));
      }
    },
  },
  validations() {
    if (this.ordersConfig.orderNumberOption == 'random') {
      return {
        ordersConfig: {
          numberOfCharacters: { required, between: between(5, 20) },
        },
      };
    } else {
      return {
        ordersConfig: {
          startingNumber: { required },
        },
      };
    }
  },
  computed: {
    orderNumberOption() {
      if (this.ordersConfig != null) {
        return this.ordersConfig.orderNumberOption;
      } else {
        return 'NotLoadedYet';
      }
    },
    availableLanguages() {
      return this.$i18n.availableLocales.map((locale) => {
        return { value: locale, text: this.$t(`languages.${locale}`) };
      });
    },
  },
  watch: {
    orderNumberOption() {
      this.cancelResetStartingNumber();
    },
    selectedLang(newLang, oldLang) {
      if (oldLang != null) {
        let emailObject = {
          language: oldLang,
          approveOrderText: this.approveOrderText
            .replaceAll('\r\n', '%0D%0A')
            .replaceAll('\n', '%0D%0A'),
          approvedOrderText: this.approvedOrderText
            .replaceAll('\r\n', '%0D%0A')
            .replaceAll('\n', '%0D%0A'),
          approveOrderTitle: this.approveOrderTitle,
          approvedOrderTitle: this.approvedOrderTitle,
        };

        let foundIndex = this.emailsConfig.findIndex(
          (x) => x.language == oldLang
        );

        if (foundIndex < 0) {
          this.emailsConfig.push(emailObject);
        } else {
          this.emailsConfig[foundIndex] = emailObject;
        }
      }

      let email = this.emailsConfig.find((x) => x.language == newLang);

      if (email != null) {
        this.approveOrderText = email.approveOrderText;
        this.approveOrderTitle = email.approveOrderTitle;
        this.approvedOrderText = email.approvedOrderText;
        this.approvedOrderTitle = email.approvedOrderTitle;
      } else {
        let defaultIndex = DEFAULT_EMAILS.findIndex(
          (x) => x.language == newLang
        );
        this.approveOrderText = DEFAULT_EMAILS[defaultIndex].approveOrderText;
        this.approveOrderTitle = DEFAULT_EMAILS[defaultIndex].approveOrderTitle;
        this.approvedOrderText = DEFAULT_EMAILS[defaultIndex].approvedOrderText;
        this.approvedOrderTitle =
          DEFAULT_EMAILS[defaultIndex].approvedOrderTitle;
      }

      this.approveOrderText = this.approveOrderText.replaceAll('%0D%0A', '\n');
      this.approvedOrderText = this.approvedOrderText.replaceAll(
        '%0D%0A',
        '\n'
      );
    },
  },
};
</script>

<template>
  <HeaderContentLayout :title="$t('ordersConfig.ordersConfig')">
    <template v-slot:header>
      <b-button type="button" variant="success" @click="saveConfig">{{
        $t('general.save')
      }}</b-button>
    </template>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <b-container v-if="ordersConfig != null" fluid>
      <!-- Orders config -->
      <b-row>
        <b-col lg="6">
          <h4>{{ $t('general.general') }}</h4>
          <b-form-group
            id="input-group-order-number-method"
            :label="$t('ordersConfig.numberMethod')"
            label-for="input-order-number-method"
          >
            <b-form-select
              id="input-order-number-method"
              v-model="ordersConfig.orderNumberOption"
            >
              <b-form-select-option value="incremental">{{
                $t('ordersConfig.incremental')
              }}</b-form-select-option>
              <b-form-select-option value="random">{{
                $t('ordersConfig.random')
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
          <div v-if="ordersConfig.orderNumberOption == 'random'">
            <b-form-group
              id="input-group-random-number"
              :label="$t('ordersConfig.numberOfChararcters')"
              label-for="input-random-number"
            >
              <b-form-input
                id="input-random-number"
                :class="{
                  'is-invalid': $v.ordersConfig.numberOfCharacters.$error,
                }"
                type="number"
                v-model="ordersConfig.numberOfCharacters"
                @keydown.enter.prevent="saveConfig"
                step="1"
                min="5"
                max="20"
                :placeholder="$t('ordersConfig.numberOfChararcters')"
              ></b-form-input>
              <Tooltip :validations="$v.ordersConfig.numberOfCharacters" />

              <small>
                {{ $t('ordersConfig.sevenCharacterOrMoreRecommended') }}
              </small>
            </b-form-group>
          </div>
          <div v-else>
            <b-form-group
              id="input-group-starting-number"
              :label="
                $t(
                  ordersConfig.orderNumberOption == 'random'
                    ? 'ordersConfig.numberOfChararcters'
                    : 'ordersConfig.startingNumber'
                )
              "
              label-for="input-starting-number"
            >
              <b-input-group>
                <template #append>
                  <b-input-group-text
                    v-if="!isModifyStartingNumber"
                    class="bg-primary text-white"
                    style="cursor: pointer"
                    @click="resetStartingNumber"
                  >
                    {{ $t('ordersConfig.resetStartingNumber') }}
                  </b-input-group-text>
                </template>

                <b-form-input
                  id="input-starting-number"
                  :class="{
                    'is-invalid': $v.ordersConfig.startingNumber.$error,
                  }"
                  :disabled="!isModifyStartingNumber"
                  @keydown.escape.prevent="cancelResetStartingNumber"
                  @keydown.enter.prevent="saveConfig"
                  type="number"
                  ref="startingNumberInput"
                  step="1"
                  v-model="ordersConfig.startingNumber"
                  :placeholder="$t('ordersConfig.newStartingNumber')"
                >
                </b-form-input>
                <Tooltip :validations="$v.ordersConfig.startingNumber" />
              </b-input-group>
            </b-form-group>
          </div>
          <div>
            <b-form-group
              id="input-group-split-workorders"
              :label="$t('ordersConfig.orderItemsOptions')"
              label-for="input-split-workorders"
            >
              <b-form-checkbox
                id="input-split-workorders"
                v-model="ordersConfig.splitItemsByWorkOrder"
              >
                {{ $t('ordersConfig.splitItemsByWorkOrder') }}
              </b-form-checkbox>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <!-- Emails config -->
      <b-row>
        <b-col lg="6">
          <h4>{{ $t('general.email') }}</h4>

          <b-form-group
            id="input-group-email-language"
            :label="$t('general.language')"
            label-for="input-email-language"
          >
            <b-form-select
              id="input-email-language"
              v-model="selectedLang"
              :options="availableLanguages"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6">
          <div class="form-group">
            <div class="flex-bottom-align mb-1">
              <label class="mb-0" for="input-email-approve-text">
                {{ $t('orders.approveOrders') }}
              </label>
            </div>

            <b-form-input
              class="mb-2 mr-2"
              id="input-email-approve-title"
              ref="approveEmailTitleRef"
              v-model="approveOrderTitle"
              @focus="currentFocusedBox = 'approveEmailTitleRef'"
            ></b-form-input>

            <b-form-textarea
              id="input-email-approve-text"
              rows="7"
              ref="approveEmailTextRef"
              @focus="currentFocusedBox = 'approveEmailTextRef'"
              v-model="approveOrderText"
            ></b-form-textarea>
          </div>
        </b-col>
        <b-col lg="6">
          <div class="form-group">
            <div class="flex-bottom-align mb-1">
              <label class="mb-0" for="input-email-approved-text">
                {{ $t('orders.approvedOrders') }}
              </label>
            </div>

            <b-form-input
              class="mb-2 mr-2"
              id="input-email-approved-title"
              ref="approvedEmailTitleRef"
              v-model="approvedOrderTitle"
              @focus="currentFocusedBox = 'approvedEmailTitleRef'"
            ></b-form-input>

            <b-form-textarea
              id="input-email-approved-text"
              rows="7"
              ref="approvedEmailTextRef"
              @focus="currentFocusedBox = 'approvedEmailTextRef'"
              v-model="approvedOrderText"
            ></b-form-textarea>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="insertText('[[COMPANY]]')"
            size="sm"
            class="mb-2 mr-2"
          >
            {{ $t('general.company') }}
          </b-button>
          <b-button
            @click="insertText('[[EXT_NUMBER]]')"
            size="sm"
            class="mb-2 mr-2"
          >
            {{ $t('orders.externalNumber') }}
          </b-button>
          <b-button
            @click="insertText('[[SUPPLIER]]')"
            size="sm"
            class="mb-2 mr-2"
          >
            {{ $t('suppliers.supplierName') }}
          </b-button>
          <b-button
            @click="insertText('[[LINK]]')"
            size="sm"
            class="mb-2 mr-2"
            >{{ $t('general.link') }}</b-button
          >
          <b-button
            @click="insertText('[[PO_NUMBER]]')"
            size="sm"
            class="mb-2 mr-2"
            >{{ $t('orders.poNumber') }}</b-button
          >
          <b-button
            @click="insertText('[[NUMBER_OF_ITEMS]]')"
            size="sm"
            class="mb-2 mr-2"
            >{{ $t('orders.numberOfItems') }}</b-button
          >
          <b-button
            @click="insertText('[[ETA_DATE]]')"
            size="sm"
            class="mb-2 mr-2"
            >{{ $t('orders.etaDate') }}</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </HeaderContentLayout>
</template>